import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import size from 'lodash/size'
import replace from 'lodash/replace'
import capitalize from 'lodash/capitalize'
import isUndefined from 'lodash/isUndefined'
import dayjs from 'dayjs'
import authService from 'authService'

const authApp = process.env.REACT_APP_AUTH_URL

export const getUsers = async ({
  is_fraudulent = false,
  search = '',
  page = 1,
  limit = 7
}) => {
  const paginated = true
  const { data } = await axiosRequest({
    url: '/admin/users',
    method: 'GET',
    params: {
      is_fraudulent,
      paginated,
      limit,
      page,
      search,
      includeTransactionSummary: !is_fraudulent
    }
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

export const getApiRoles = async () => {
  const paginated = true
  const { data } = await axiosRequest({
    baseURL: authApp,
    url: '/role/',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    }
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

export const getApiUsers = async ({
  is_fraudulent = false,
  search = '',
  page = 1,
  limit = 7
}) => {
  const paginated = true
  const { data } = await axiosRequest({
    baseURL: authApp,
    url: '/user/',
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    }
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

export const getApiLogs = async ({
  is_fraudulent = false,
  search = '',
  page = 1,
  limit = 7,
  dateRange = {
    startDate: "2024-01-01T00:00:00Z",
    endDate: "2024-10-02T19:00:00Z"
  },
  filter = []
}) => {
  const paginated = true
  const { data } = await axiosRequest({
    baseURL: authApp,
    url: '/event/logs',
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    },
    data: {
      page: page - 1,
      size: limit,
      dateRange,
      sort: {
        name: "date",
        order: "desc"
      },
      filter: [...filter, ...(isEmpty(search) ? [] : [{ key: "name", value: capitalize(search) }])]
    }
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

export const getSupportInfo = async ({
  filterSelected = '',
  search = '',
  page = 1,
  limit = 7,
  type = ""
}) => {
  const paginated = true
  const { data } = await axiosRequest({
    url: '/support/admin',
    method: 'GET',
    params: {
      paginated,
      limit,
      page,
      search: replace(search, /\+/gm, '%2B'),
      status: filterSelected ? filterSelected : undefined,
      type: type ? type : undefined
    }
  })

  if (isUndefined(data)) throw new Error('')

  return data
}

export const getTransactions = async ({
  user,
  startDate = new Date(),
  endDate = new Date()
}) => {
  const start_date = dayjs(startDate).format('YYYY-MM-DD')
  const end_date = dayjs(endDate).format('YYYY-MM-DD')

  const { data } = await axiosRequest({
    url: '/admin/user-transactions',
    method: 'GET',
    params: {
      uuid: user,
      start_date,
      end_date,
      page: 1,
      limit: Number.MAX_SAFE_INTEGER,
      paginated: true
    }
  })
  return data
}

const getProperty = (user: any, property: string) => {
  const prop = get(user, property, '')
  if (size(prop) < 1) return undefined

  return prop
}

export const mergeUsers = async ({ user, userToMerge }) => {
  const data = await axiosRequest({
    url: '/admin/users/restore',
    method: 'POST',
    data: {
      newAccount: {
        uuid: user.identity_uuid,
        phone: getProperty(user, 'identity_phone'),
        email: getProperty(user, 'identity_email')
      },
      oldAccount: {
        uuid: userToMerge.identity_uuid,
        phone: getProperty(userToMerge, 'identity_phone'),
        email: getProperty(userToMerge, 'identity_email')
      }
    }
  })

  if (size(get(data, 'response.data.error'))) throw new Error('Request Error')

  return data
}
